import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, Typography } from '@mui/material';
import React from 'react';
import {
  ISIVChecklistClinicalTrialData,
  ISIVChecklistInformedConsentVerification,
  ISIVChecklistSiteAdequacy
} from 'src/types/SIVChecklist';
import ClinicalTrialDetails from './ClinicalTrialDetails';
import InformedConsentVerification from './InformedConsentVerification';
import SiteAdequacy from './SiteAdequacy';
import './SivChecklist.scss';
import {
  ISIVChecklistMandatory,
  ISIVChecklistModifiedKeys,
  ISIVChecklistModifiedKeysOfKeys,
  ISIVChecklistStep1Accordions,
  MandatoryData
} from './useSivChecklist';

export interface ISQChecklistPage {
  getSivChecklistData: (key: ISIVChecklistModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  setSaveDisable: (saveDisable: boolean) => void;
  expandedState: ISIVChecklistStep1Accordions;
  toggle: (key: keyof ISIVChecklistStep1Accordions, expanded: boolean) => void;
  clinicalTrialData: ISIVChecklistClinicalTrialData;
  updateClinicalData: (data: ISIVChecklistClinicalTrialData) => void;
  isUpdate: boolean;
  setIsUpdate: (isUpdate: boolean) => void;
  siteAdequacyData: ISIVChecklistSiteAdequacy;
  updateSiteAdequacyData: (data: ISIVChecklistSiteAdequacy) => void;
  informedConsentVerificationData: ISIVChecklistInformedConsentVerification;
  updateIinformedConsentVerification: (data: ISIVChecklistInformedConsentVerification) => void;
  Step1: ISIVChecklistStep1Accordions;
  setIsChange: (step: ISIVChecklistModifiedKeys, key: ISIVChecklistModifiedKeysOfKeys, val: boolean) => void;
  updateSIVChecklistMandatoryData: (key: keyof ISIVChecklistMandatory, value: MandatoryData) => void;
  mandatory: ISIVChecklistMandatory;
  validateclinicalTrialDetails: any;
  validatesiteAdequacy: any;
  validateinformedConsentVerification: any;
  checkedInStartDate: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
}

const SQChecklistPage: React.FunctionComponent<ISQChecklistPage> = ({
  getSivChecklistData,
  saveDisable,
  setSaveDisable,
  expandedState,
  toggle,
  clinicalTrialData,
  updateClinicalData,
  isUpdate,
  siteAdequacyData,
  updateSiteAdequacyData,
  informedConsentVerificationData,
  updateIinformedConsentVerification,
  Step1,
  setIsChange,
  updateSIVChecklistMandatoryData,
  mandatory,
  validateclinicalTrialDetails,
  validatesiteAdequacy,
  validateinformedConsentVerification,
  checkedInStartDate,
  isPublished,
  SignatureBreaking
}) => {
  return (
    <div className="pi-accordion siv-accordion">
      <Accordion
        expanded={expandedState.clinicalTrialDetails}
        onChange={(_, expanded) => {
          toggle('clinicalTrialDetails', expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
          <Typography>Clinical Trial Details </Typography>
        </AccordionSummary>

        <ClinicalTrialDetails
          getSivChecklistData={getSivChecklistData}
          saveDisable={saveDisable}
          setSaveDisable={setSaveDisable}
          isChange={Step1.clinicalTrialDetails}
          clinicalTrialData={clinicalTrialData}
          updateClinicalData={updateClinicalData}
          isUpdate={isUpdate}
          setIsChange={setIsChange}
          updateSIVChecklistMandatoryData={updateSIVChecklistMandatoryData}
          mandatory={mandatory.clinicalTrialDetails}
          validateclinicalTrialDetails={validateclinicalTrialDetails}
          checkedInStartDate={checkedInStartDate}
          isPublished={isPublished}
          SignatureBreaking={SignatureBreaking}
        />
      </Accordion>

      <Accordion
        expanded={expandedState.siteAdequacy}
        onChange={(_, expanded) => {
          toggle('siteAdequacy', expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
          <Typography sx={{ width: '33%', flexShrink: 0 }}>
            Site Adequacy{' '}
            {/* <Button variant="text" className="btn-static">
              <OpenInNewIcon />
            </Button> */}
          </Typography>
        </AccordionSummary>
        <SiteAdequacy
          getSivChecklistData={getSivChecklistData}
          saveDisable={saveDisable}
          setSaveDisable={setSaveDisable}
          isUpdate={isUpdate}
          siteAdequacyData={siteAdequacyData}
          isChange={Step1.siteAdequacy}
          updateSiteAdequacyData={updateSiteAdequacyData}
          setIsChange={setIsChange}
          updateSIVChecklistMandatoryData={updateSIVChecklistMandatoryData}
          mandatory={mandatory.siteAdequacy}
          validatesiteAdequacy={validatesiteAdequacy}
          checkedInStartDate={checkedInStartDate}
          isPublished={isPublished}
          SignatureBreaking={SignatureBreaking}
        />
      </Accordion>
      <Accordion
        expanded={expandedState.informedConsentVerification}
        onChange={(_, expanded) => {
          toggle('informedConsentVerification', expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel3bh-header">
          <Typography sx={{ width: '33%', flexShrink: 0 }}>Informed Consent </Typography>
        </AccordionSummary>
        <InformedConsentVerification
          getSivChecklistData={getSivChecklistData}
          saveDisable={saveDisable}
          setSaveDisable={setSaveDisable}
          informedConsentVerificationData={informedConsentVerificationData}
          isUpdate={isUpdate}
          updateIinformedConsentVerification={updateIinformedConsentVerification}
          isChange={Step1.informedConsentVerification}
          setIsChange={setIsChange}
          updateSIVChecklistMandatoryData={updateSIVChecklistMandatoryData}
          mandatory={mandatory.informedConsentVerification}
          validateinformedConsentVerification={validateinformedConsentVerification}
          checkedInStartDate={checkedInStartDate}
          isPublished={isPublished}
          SignatureBreaking={SignatureBreaking}
        />
      </Accordion>
    </div>
  );
};

export default SQChecklistPage;
